function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/* eslint-disable @typescript-eslint/no-use-before-define */

import * as React from 'react';
import { Action, EntrySectionUpdates, EntryType, GroupEventBehaviors, isMetricEntry, QueryEventEntry, QueryGroupedEntry, RowLabelType, SelectorTypeDefinitions } from 'common/query-builder/query-entry-section/types';
// eslint-disable-next-line import/no-cycle
import { QueryEntrySectionReact } from 'common/query-builder/query-entry-section';
import { QueryEntrySectionTrackingEvent } from 'common/query-builder/query-entry-section/tracking';
import { BaseEntryRow } from '../base';
import type { EntryRowProps } from '../types';

/**
 * QueryGroupedEntryRow renders a grouped event row (nested events)
 */
export function GroupedEntryRow(props: EntryRowProps<QueryGroupedEntry>) {
  const onGroupLabelClick = () => {
    if (props.sectionProps.rowIndexToggleable && !isMetricEntry(props.entry)) {
      props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
        entryIndexLabelToggle: !props.entry.entryIndexLabelToggle
      }));
      props.dispatchTrack(QueryEntrySectionTrackingEvent.EventIndexLabelClicked, _objectSpread(_objectSpread({}, props.getEntryTrackingProps()), {}, {
        'Previous Label': props.rowLabel
      }));
    }
  };
  const onUpdate = (_ref: EntrySectionUpdates<QueryEventEntry>) => {
    let {
      entries
    }: EntrySectionUpdates<QueryEventEntry> = _ref;
    if (isMetricEntry(props.entry)) {
      return;
    }
    if (entries.length === 1 && props.entry.type === SelectorTypeDefinitions.GroupedEvent && props.entry.event.length > 1) {
      // if there is now only one entry left, ungroup it
      props.updateEntry(Action.Ungroup, entries[0]);
    } else {
      // otherwise just update the entries
      props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
        type: SelectorTypeDefinitions.GroupedEvent,
        event: entries,
        filters: []
      }));
    }
  };
  return <BaseEntryRow {...props} hideActions isPlaceholder={false} showLabels={false} renderSelector={_ref2 => {
    let {
      rowIcon
    } = _ref2;
    return <QueryEntrySectionReact elref='subEntry' className='sub-entry' containedSection {...props.nestedSectionParams} entryType={EntryType.Event} rowLabelPrefix={props.rowLabel} {...rowIcon ? {
      rowLabelPrefixIcon: rowIcon
    } : {}} rowLabelType={RowLabelType.Alpha} rowIndex={props.index} rowIndexToggleable={props.sectionProps.rowIndexToggleable} rowIndexToggleIcon={props.sectionProps.rowIndexToggleIcon} rowDraggable={false} groupEventBehavior={GroupEventBehaviors.Append} trackProperties={_objectSpread(_objectSpread({}, props.nestedSectionParams.trackProperties || {}), {}, {
      sectionName: "grouped-entry"
    })} entries={props.entry.event} onUpdate={onUpdate} onEntryGroupLabelClicked={onGroupLabelClick} />;
  }} overflowControls={props.getCommonOverflowControls()} data-sentry-element="BaseEntryRow" data-sentry-component="GroupedEntryRow" data-sentry-source-file="index.tsx" />;
}